import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';

const mobileSharedImport = () => import(/* webpackChunkName: "manual-mobile-shared" */ './components/MobileSharedSession');

const ManualPublicRoutes = [
  <BundleRoute
    key="mobile-shared-session"
    load={mobileSharedImport}
    path="/live/mobile/dataCenters/:dataCenterId/devices/:deviceId/shared/:sessionId"
  />,
];

ManualPublicRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default ManualPublicRoutes;
